import { render, staticRenderFns } from "./modalDemorado.vue?vue&type=template&id=180fb4b2"
import script from "./modalDemorado.vue?vue&type=script&lang=js"
export * from "./modalDemorado.vue?vue&type=script&lang=js"
import style0 from "./modalDemorado.vue?vue&type=style&index=0&id=180fb4b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports